import { Pencil, Users, EyeOff, Clock } from 'lucide-react';
import { ROUTES } from '@/constants/routes';

export const ENROLL_DFW_URL = (() => {
  const params = new URLSearchParams();
  params.append('locations', 'Dallas, TX');
  params.append('locations', 'Fort Worth, TX');
  return `${ROUTES.enroll}?${params}`;
})();

export const CLASSROOM_FEATURES = [
  {
    icon: Pencil,
    title: 'Whiteboards and notebooks',
    description:
      'The whole room is set up for thinking out loud, not staring at screens. Markers, paper, and erasers within reach of every seat.',
  },
  {
    icon: Users,
    title: 'Five chairs, never more',
    description:
      'Four students and one teacher. The room is sized for the class, so it never feels crowded and never feels empty.',
  },
  {
    icon: EyeOff,
    title: 'No electronics during class',
    description:
      'Phones, tablets, and laptops stay in bags. We bring out a calculator only when the curriculum actually calls for one.',
  },
  {
    icon: Clock,
    title: 'Predictable hours',
    description:
      'Classes start on time and end on time. We respect the schedule you gave us, and we expect students to do the same.',
  },
];